export default __webpack_public_path__ + "static/media/marker2.f7e8388c.png";